import ImagePlaceholder from '~/assets/images/core/placeholder.png';

const URL_SITE = import.meta.env.VITE_SITE_URL;
const URL_PANEL = import.meta.env.VITE_PANEL_URL;
const URL_REGISTER = URL_PANEL + '/register';
const URL_LOGIN = URL_PANEL + '/login';
const URL_TERMS = URL_SITE + '/terms';
const URL_WAREHOUSE_HOME = URL_SITE + '/@%s';

const noImage = ImagePlaceholder;

export { noImage, URL_SITE, URL_PANEL, URL_TERMS, URL_REGISTER, URL_LOGIN, URL_WAREHOUSE_HOME };
